/* @flow */
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';
import ReactSlider from 'react-slider';
import cx from 'classnames';
import './styles/Slider.scss';

class Slider extends React.Component {
  static propTypes = {
    min: React.PropTypes.number.isRequired,
    max: React.PropTypes.number.isRequired,
    step: React.PropTypes.number,
    value: React.PropTypes.number.isRequired,
    onBeforeChange: React.PropTypes.func,
    onChange: React.PropTypes.func,
    onAfterChange: React.PropTypes.func,
    theme: React.PropTypes.oneOf(['light', 'dark']).isRequired,
    size: React.PropTypes.oneOf(['thick', 'thin']).isRequired,
  };

  static propClasses = {
    theme: {
      light: 'Slider-light',
      dark: 'Slider-dark',
    },
    size: {
      thick: 'Slider-thick',
      thin: 'Slider-thin',
    },
  };

  static defaultProps = {
    step: 1,
  };

  componentDidUpdate(prevProps: Object) {
    if (this._slider && this.props.max !== prevProps.max) {
      this._slider._handleResize();
    }
  }
  _slider = null;

  render() {
    return (
      <ReactSlider
        ref={c => (this._slider = c)}
        className={cx('Slider', getPropClassesFromInstance(this))}
        min={this.props.min}
        max={this.props.max}
        step={this.props.step}
        value={this.props.value}
        orientation="horizontal"
        withBars
        onBeforeChange={this.props.onBeforeChange}
        onChange={this.props.onChange}
        onAfterChange={this.props.onAfterChange}
      />
    );
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Slider.jsx